import ListViewName from "../listviews/ListViewName";

import Space from "../layout/Space";

import DropDownGPT0 from "../dropdowns/DropDownGTP0";
import { Spin } from "antd";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3";
import SmallSpinner from "../loading/SmallSpinner";

function MMName({
  title,
  users,
  loading = false,
  removable,
  placeholder = "Nom",
  className = "",
  options,
  label = "",
  value = null,
  setValue,
  onAction,
  type,
  onDelete,
  icon_name,
}) {
  console.log("MMName", options);
  return (
    <div className={`min-h-fit ${className}`}>
      {loading && (
        <div className="text-h2 font-semibold text-pr w-full">
          <SmallSpinner></SmallSpinner>{" "}
        </div>
      )}
      <Space y={10} />
      <div className="w-full h-fit">
        <DropDownGPTS3
          label={label}
          value={value}
          items={options}
          onChange={(newValue) => onAction(newValue)}
          className=" w-full"
        ></DropDownGPTS3>
        <Space x={0} />
      </div>
      <Space y={10} />
      <div className="w-full">
        {users !== null && users.length > 0 && (
          <ListViewName
            icon_name={icon_name}
            users={users}
            removable={removable}
            type={type}
            onDelete={onDelete}
          ></ListViewName>
        )}
      </div>
    </div>
  );
}

export default MMName;
